import { Link } from "react-router-dom";
import { getComicById } from "@/mocks/comics";
import type { Comic } from "@/mocks/comics";

const rankIds = ["shanhaijuan", "xindongxuqu", "wojiashatiaomiao", "dishihao", "ranhun", "xingchenyuanzheng", "wuyemian", "jixiejiyuan"];
const ranking = rankIds.map((id) => getComicById(id)).filter(Boolean) as Comic[];

function rankBadge(idx: number) {
  if (idx === 0) return "bg-accent-500 text-background-50";
  if (idx === 1) return "bg-secondary-500 text-background-50";
  if (idx === 2) return "bg-primary-600 text-background-50";
  return "bg-secondary-200 text-secondary-700";
}

export default function RankingSection() {
  return (
    <section className="bg-background-50 py-12 md:py-16" aria-labelledby="ranking-heading">
      <div className="container-x">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
              <i className="ri-trophy-fill"></i> 人气飙升
            </span>
            <h2 id="ranking-heading" className="mt-3 font-display text-2xl font-black text-foreground-900 md:text-3xl">
              漫画排行榜
            </h2>
          </div>
          <Link to="/category/all?sort=views" className="flex items-center gap-1 text-sm font-semibold text-primary-600 hover:text-primary-700">
            完整榜单 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <ol className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {ranking.map((comic, idx) => (
            <li key={comic.id}>
              <Link
                to={`/comic/${comic.id}`}
                className="flex items-center gap-4 rounded-lg border border-background-200/70 bg-background-50 p-3 transition-all duration-300 hover:border-primary-200 hover:bg-primary-50/40 md:p-4"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-sm font-black ${rankBadge(idx)}`}
                >
                  {idx + 1}
                </span>
                <div className="h-16 w-12 shrink-0 overflow-hidden rounded-md bg-background-100 md:h-20 md:w-14">
                  <img src={comic.cover} alt={`${comic.title}封面`} className="h-full w-full object-cover object-top" />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-bold text-foreground-900 md:text-base group-hover:text-primary-600">
                    {comic.title}
                  </h3>
                  <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-600 md:text-sm">
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-star-fill text-accent-500"></i>
                      {comic.rating}
                    </span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-eye-line"></i>
                      {comic.views}
                    </span>
                    <span className="hidden whitespace-nowrap text-foreground-400 sm:inline">{comic.status}</span>
                  </p>
                </div>
                <span className="shrink-0 rounded-md bg-primary-100 px-3 py-1.5 text-xs font-semibold text-primary-700">
                  {comic.categoryName}
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}